import { useEffect,useState } from "react"
import {Col, Container, Row} from "react-bootstrap"
import {ArrowRightCircle} from "react-bootstrap-icons"
import headerImg from "../assets/img/header-img.svg"
import MadhavResume from "../assets/img/Madhav_resume.pdf"
const Banner = () => {

    const handleDownload = () => {
        const anchor = document.createElement('a');
        anchor.href = MadhavResume;
        anchor.download = 'Madhav_resume.pdf';
        anchor.click();
      };
    const [loopNum, setLoopNum] = useState(0); 
    const [isDeleting, setIsDeleting] = useState(false);
    const toRotate = ["Web Developer","Competitive Programmer","Stock Trader"];
    const[text, setText] = useState('');
    const[delta,setDelta] = useState(300 - Math.random()*100);
    const period = 500;

    useEffect (() => {
        let ticker = setInterval (() => {
             tick();

        },delta)
        return () =>{clearInterval(ticker)};
    },[text])

    const tick =() =>{
        let i = loopNum % toRotate.length;
        let fullText = toRotate[i];
        let updatedText = isDeleting ? fullText.substring(0,text.length - 1) : fullText.substring(0, text.length + 1);
        setText(updatedText);
        if(isDeleting){
            setDelta(prevDelta => prevDelta/2)
        }
        if(!isDeleting && updatedText === fullText)
        {
            setIsDeleting(true);
            setDelta(period);
        }else if(isDeleting && updatedText === '')
        {
            setIsDeleting(false);
            setLoopNum(loopNum + 1);
            setDelta(500);
        }
    }
  return (
    <section className="banner" id="home">
        <Container>
            <Row className="align-items-center">
                <Col xs={12} md={6} xl={7}>
                    <span className="tagline">Welcome to my Portfolio</span>
                    <h1>{`Hi I'm Madhav Somani `}<span className="wrap">{text}</span></h1>
                    <p> A tech enthusiast by day, problem-solving ninja by night—bringing humor to bugs and charm to code! Also, a music aficionado weaving melodies into algorithms.</p>
                    
                    <button onClick={handleDownload}>Checkout My Resume <ArrowRightCircle /></button>
                </Col>
                <Col xs={12} md={6} xl={5}>
                    <img src={headerImg} alt="Header Img"/>
                </Col>
            </Row>
        </Container>
    </section>
  )
}

export default Banner
